import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ArrowRightIcon, ZapIcon } from 'lucide-react';
const includes = ['Clase en vivo 90 minutos (22 de abril, 7:30 PM)', 'Grabación de por vida', 'Prompt maestro', 'Plantilla de copy', 'Q&A en vivo', 'Comunidad privada'];
export function OfferBox() {
  return <section className="py-20 px-4 bg-violet-50" data-id="element-83">
      <div className="max-w-4xl mx-auto" data-id="element-84">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="relative bg-white border-4 border-violet-600 rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-85">
          <div className="absolute -top-4 left-1/2 transform -translate-x-1/2" data-id="element-86">
            <span className="inline-block bg-violet-600 text-white px-6 py-2 rounded-full font-bold text-sm tracking-wide shadow-lg" data-id="element-87">
              Acceso Completo
            </span>
          </div>

          <h3 className="font-playfair text-3xl md:text-5xl font-bold text-gray-900 mb-8 text-center mt-4" data-id="element-88">
            Workshop: Tu Website en 5 Minutos con IA
          </h3>

          <div className="mb-8" data-id="element-89">
            <h4 className="font-bold text-xl text-gray-900 mb-4" data-id="element-90">Incluye:</h4>
            <ul className="space-y-3" data-id="element-91">
              {includes.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-92">
                  <CheckIcon className="w-6 h-6 text-violet-600 flex-shrink-0 mt-1" data-id="element-93" />
                  <span className="text-lg text-gray-800" data-id="element-94">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="border-t-2 border-gray-200 pt-8 mb-8" data-id="element-95">
            <div className="text-center mb-6" data-id="element-96">
              <p className="text-gray-600 text-lg mb-2" data-id="element-97">Precio:</p>
              <p className="font-playfair text-5xl font-bold text-violet-600 mb-2" data-id="element-98">
                $87 USD
              </p>
              <p className="text-gray-600" data-id="element-99">Pago único · Acceso inmediato</p>
            </div>

            <motion.a href="https://sharontirado.mykajabi.com/offers/JCeY2FLo" target="_blank" rel="noopener noreferrer" className="block w-full text-center px-10 py-5 bg-gradient-to-r from-violet-600 to-violet-700 text-white text-xl font-bold rounded-xl shadow-lg hover:shadow-xl transition-all" whileHover={{
            scale: 1.02,
            y: -2
          }} whileTap={{
            scale: 0.98
          }} data-id="element-100">
              <span className="flex items-center justify-center gap-3" data-id="element-101">
                RESERVAR MI LUGAR
                <ArrowRightIcon className="w-6 h-6" data-id="element-102" />
              </span>
            </motion.a>
          </div>

          <div className="bg-yellow-50 border-2 border-yellow-300 rounded-lg p-4 text-center" data-id="element-103">
            <p className="flex items-center justify-center gap-2 text-gray-800 font-semibold" data-id="element-104">
              <ZapIcon className="w-5 h-5 text-yellow-600" data-id="element-105" />
              El precio aumentará en 24 horas
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}